module.exports = __webpack_public_path__ + "img/community-impostor.88bba9c5.webp";